export { getBasketServerAction } from 'next-flight-server-reference-proxy-loader?id=40fe1bcfc491876c88716946024b1c3ea7a28cd324&name=getBasketServerAction!'